/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_OxfordsInputs */

const en_val_oxfords = /** @type {(inputs: Val_OxfordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oxfords`)
};

const es_val_oxfords = /** @type {(inputs: Val_OxfordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapatos Oxford`)
};

const fr_val_oxfords = /** @type {(inputs: Val_OxfordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richelieus`)
};

const de_val_oxfords = /** @type {(inputs: Val_OxfordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oxfords`)
};

const ja_val_oxfords = /** @type {(inputs: Val_OxfordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オックスフォード`)
};

const zh_val_oxfords = /** @type {(inputs: Val_OxfordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`牛津鞋`)
};

const ar_val_oxfords = /** @type {(inputs: Val_OxfordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أحذية أكسفورد`)
};

const id_val_oxfords = /** @type {(inputs: Val_OxfordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oxfords`)
};

const it_val_oxfords = /** @type {(inputs: Val_OxfordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stringate (Oxfords)`)
};

const ru_val_oxfords = /** @type {(inputs: Val_OxfordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оксфорды`)
};

const pt_val_oxfords = /** @type {(inputs: Val_OxfordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sapatos Oxford`)
};

const ko_val_oxfords = /** @type {(inputs: Val_OxfordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`옥스포드화`)
};

/**
* | output |
* | --- |
* | "Oxfords" |
*
* @param {Val_OxfordsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_oxfords = /** @type {((inputs?: Val_OxfordsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_OxfordsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_oxfords(inputs)
	if (locale === "es") return es_val_oxfords(inputs)
	if (locale === "fr") return fr_val_oxfords(inputs)
	if (locale === "de") return de_val_oxfords(inputs)
	if (locale === "ja") return ja_val_oxfords(inputs)
	if (locale === "zh") return zh_val_oxfords(inputs)
	if (locale === "ar") return ar_val_oxfords(inputs)
	if (locale === "id") return id_val_oxfords(inputs)
	if (locale === "it") return it_val_oxfords(inputs)
	if (locale === "ru") return ru_val_oxfords(inputs)
	if (locale === "pt") return pt_val_oxfords(inputs)
	return ko_val_oxfords(inputs)
});